import { ELEMENT_H1, ELEMENT_PARAGRAPH } from '@doltech/utils/lib/constants';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { getNodeText } from '../../../../../../figma/BlogEditor/plugins/shared-transforms';
import { colorsV2 } from '../../../../../../figma/colors-v2';

const Main = styled.div`
  position: relative;

  .placeholder {
    position: absolute;
    left: 0;
    pointer-events: none;
    color: ${colorsV2.gray60};

    &.have-text,
    &.focused {
      display: none;
      z-index: -1;
    }
  }

  &.read-only.empty-text {
    display: none;
  }
`;

interface EditorPlaceHolderProps {
  children: JSX.Element;
  placeHolderText: string;
  isEmptyText: () => boolean;
  isReadOnly?: boolean;
  className?: string;
  placeholderClassName?: string;
}

export const defaultIsEmptyText = (element) => {
  const text = getNodeText(element);
  const deepNode = element?.children?.[0]?.children?.[0];
  if (deepNode?.children?.length > 0 && (deepNode?.type !== ELEMENT_PARAGRAPH || deepNode?.type !== ELEMENT_H1)) {
    return false;
  }
  if (text && text.trim) {
    return text.trim().length === 0;
  }
  return true;
};

export const isNodeStringEmpty = (content: string) => {
  if (!content) {
    return false;
  }
  try {
    const node = JSON.parse(content);
    return defaultIsEmptyText(node);
    // eslint-disable-next-line no-empty
  } catch (ex) {}
  return false;
};

export const EditorPlaceHolder = ({
  children,
  placeHolderText,
  isEmptyText,
  className,
  placeholderClassName,
}: EditorPlaceHolderProps) => {
  return (
    <Main
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) e.preventDefault();
      }}
      className={cl({ 'empty-text': isEmptyText() })}
    >
      <div
        contentEditable={false}
        className={cl('placeholder', { 'have-text': !isEmptyText() }, placeholderClassName)}
      >
        {placeHolderText}
      </div>
      <div className={cl('text', className)}>{children}</div>
    </Main>
  );
};

export const PlaceHolder = ({
  children,
  placeHolderText,
  isEmptyText,
  className,
  placeholderClassName,
}: EditorPlaceHolderProps) => {
  const haveText = !isEmptyText();

  if (haveText) {
    return <div className={cl('element-placeholder text', className)}>{children}</div>;
  }

  return (
    <Main className={cl('element-placeholder empty-text', 'read-only')}>
      <div contentEditable={false} className={cl('placeholder', placeholderClassName)}>
        {placeHolderText}
      </div>
      <div className={cl('text', className)}>{children}</div>
    </Main>
  );
};
